import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      background: '#FFFFFF',
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '120%'),
      padding: '20px 40px',
      textAlign: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'start'),
    },
    title: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '14px',
      color: '#000000',
      margin: '10px 0',
    },
    subTitle: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '14px',
      color: '#888B8D',
      margin: '5px 0',
      '&:hover': {
        color: '#2D6DF6',
      },
    },
    divIcons: {
      display: 'flex',
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'space-between'),
    },
    divPhone: {
      width: '230px',
      height: '35px',
      background: '#2D6DF6',
      borderRadius: '28px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '10px',
    },
    labelPhone: {
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      color: '#FFFFFF',
      marginLeft: '10px',
    },
    divEmail: {
      marginTop: '30px',
    },
    divNotice: {
      display: ({ isMobile }: StyleProps) => (isMobile ? 'grid' : 'flex'),
      justifyContent: 'center',
      margin: '80px 0 10px 0',
    },
    labelLaws: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '14px',
      color: '#000000',
    },
    labelBlue: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '14px',
      color: '#2D6DF6',
      marginLeft: ({ isMobile }: StyleProps) => (isMobile ? '0' : '30px'),
    },
    divPhoneButton: {
      justifyContent: 'center',
      display: ({ isMobile }: StyleProps) => (isMobile ? 'grid' : 'block'),
    },
    link: {
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),
);

export default useStyles;
